import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest
} from "@/views/academy/api/apiRequests";
import { StorageItemDetailsApiEndpoints } from "@/views/academy/common/storageitemdetails/StorageItemDetailsApiEndpoints";
import { i18n } from "@/plugins/i18n";
import * as FileSaver from "file-saver";
import * as axios from "axios";
import {
  ApiRequestHeaderTypes,
  ApiRequestHeaderValueTypes
} from "@/views/academy/enums/ApiRequestHeaderTypes";
import { ShareStorageListItemMenuItem } from "../../enums/ShareStorageListItemMenuItem";

const state = () => ({
  storageItemFavoriteState: false,
  isPreviewDialogOpened: false,
  previewResource: null,
  storageItemDetails: null,
  searchPeopleAndTeamsToShare: null,
  isPeopleAndTeamsToShareLoading: true,
  selectedPeopleAndTeamsToShare: {
    deleted: {
      admins: [],
      orgUnits: [],
      players: []
    },
    updated: {
      admins: [],
      orgUnits: [],
      players: []
    }
  },
  searchPeopleAndTeamsToShareInDetails: {
    deleted: {
      admins: [],
      orgUnits: [],
      players: []
    },
    updated: {
      admins: [],
      orgUnits: [],
      players: []
    }
  },
  isShareListNoResult: false,
  isPreviewDialogAssignmentsMode: false,
  previewDialogFile: null,
  storageItemTags: null
});

const getters = {
  storageItemFavoriteState: (state: { storageItemFavoriteState: boolean }) =>
    state.storageItemFavoriteState,

  isPreviewDialogOpened: (state: { isPreviewDialogOpened: boolean }) =>
    state.isPreviewDialogOpened,

  previewResource: (state: { previewResource: string }) =>
    state.previewResource,

  storageItemDetails: (state: { storageItemDetails: object }) =>
    state.storageItemDetails,

  searchPeopleAndTeamsToShare: (state: {
    searchPeopleAndTeamsToShare: object;
  }) => state.searchPeopleAndTeamsToShare,

  searchPeopleAndTeamsToShareInDetails: (state: {
    searchPeopleAndTeamsToShareInDetails: object;
  }) => state.searchPeopleAndTeamsToShareInDetails,

  isPeopleAndTeamsToShareLoading: (state: {
    isPeopleAndTeamsToShareLoading: boolean;
  }) => state.isPeopleAndTeamsToShareLoading,

  selectedPeopleAndTeamsToShare: (state: {
    selectedPeopleAndTeamsToShare: object;
  }) => state.selectedPeopleAndTeamsToShare,

  isShareListNoResult: (state: { isShareListNoResult: boolean }) =>
    state.isShareListNoResult,

  isPreviewDialogAssignmentsMode: (state: {
    isPreviewDialogAssignmentsMode: boolean;
  }) => state.isPreviewDialogAssignmentsMode,

  previewDialogFile: (state: { previewDialogFile: object }) =>
    state.previewDialogFile,

  storageItemTags: (state: { storageItemTags: any }) => state.storageItemTags
};

const mutations = {
  setStorageItemFavoriteState: (
    state: {
      storageItemFavoriteState: object;
    },
    payload: any
  ) => {
    state.storageItemFavoriteState = payload;
  },

  toggleStorageItemPreviewDialog: (
    state: { isPreviewDialogOpened: any; isPreviewDialogAssignmentsMode: any },
    payload: { isPreviewDialogOpened: any; isPreviewDialogAssignmentsMode: any }
  ) => {
    state.isPreviewDialogOpened = payload.isPreviewDialogOpened;
    state.isPreviewDialogAssignmentsMode =
      payload.isPreviewDialogAssignmentsMode;
  },

  setPreviewResource: (
    state: {
      previewResource: string;
    },
    payload: string
  ) => {
    state.previewResource = payload;
  },

  clearPreviewResource: (state: { previewResource: null }) => {
    state.previewResource = null;
  },

  setSearchPeopleAndTeamsToShare: (
    state: {
      isPeopleAndTeamsToShareLoading: boolean;
      searchPeopleAndTeamsToShare: object;
    },
    payload: { isPeopleAndTeamsToShareLoading: boolean }
  ) => {
    state.isPeopleAndTeamsToShareLoading =
      payload.isPeopleAndTeamsToShareLoading;
  },

  setSearchPeopleAndTeamsToShareSuccess: (
    state: {
      isPeopleAndTeamsToShareLoading: boolean;
      searchPeopleAndTeamsToShare: object;
    },
    payload: object
  ) => {
    state.searchPeopleAndTeamsToShare = payload;
    state.isPeopleAndTeamsToShareLoading = false;
  },

  setSearchPeopleAndTeamsToShareInDetailsSuccess: (
    state: {
      isPeopleAndTeamsToShareLoading: boolean;
      searchPeopleAndTeamsToShareInDetails: object;
    },
    payload: object
  ) => {
    state.searchPeopleAndTeamsToShareInDetails = payload;
    state.isPeopleAndTeamsToShareLoading = false;
  },

  changeSelectedPeopleAndTeamsAccessType: (state: any, payload: any) => {
    const { item, newAccessType, oldAccessType } = payload;
    let arrayName = "";
    let idName = "";
    let content = {};
    if (item?.userId) {
      arrayName = "admins";
      idName = "userId";
      content = {
        accessType:
          newAccessType === ShareStorageListItemMenuItem.REMOVE
            ? oldAccessType
            : newAccessType,
        userId: item?.userId
      };
    } else if (item?.orgUnitId) {
      arrayName = "orgUnits";
      idName = "orgUnitId";
      content = {
        orgUnitId: item?.orgUnitId
      };
    } else if (item?.playerId) {
      arrayName = "players";
      idName = "playerId";
      content = {
        playerId: item?.playerId
      };
    }

    if (
      newAccessType !== ShareStorageListItemMenuItem.REMOVE &&
      oldAccessType !== newAccessType
    ) {
      state.selectedPeopleAndTeamsToShare?.updated?.[arrayName].push(content);
    } else if (newAccessType === ShareStorageListItemMenuItem.REMOVE) {
      state.selectedPeopleAndTeamsToShare?.deleted?.[arrayName].push(content);
      state.selectedPeopleAndTeamsToShare.updated = {
        ...state.selectedPeopleAndTeamsToShare.updated,
        [arrayName]: state.selectedPeopleAndTeamsToShare?.updated?.[
          arrayName
        ].filter((i: { [x: string]: any }) => i?.[idName] !== item?.[idName])
      };
    } else if (
      newAccessType !== ShareStorageListItemMenuItem.REMOVE &&
      newAccessType === oldAccessType
    ) {
      state.selectedPeopleAndTeamsToShare.updated = {
        ...state.selectedPeopleAndTeamsToShare?.updated,
        [arrayName]: state.selectedPeopleAndTeamsToShare?.updated?.[
          arrayName
        ].filter((i: { [x: string]: any }) => i?.[idName] !== item?.[idName])
      };
    }
  },
  clearSearchPeopleAndTeamsToShare: (state: {
    searchPeopleAndTeamsToShare: {};
  }) => {
    state.searchPeopleAndTeamsToShare = {};
  },

  setSearchPeopleAndTeamsToShareInDetails: (state: any, payload: any) => {
    const { item, isRemoveAccess, accessType } = payload;
    let arrayName = "";
    let idName = "";
    let content = {};
    if (item?.userId) {
      arrayName = "admins";
      idName = "userId";
      content = {
        accessType: accessType,
        userId: item?.userId
      };
    } else if (item?.orgUnitId) {
      arrayName = "orgUnits";
      idName = "orgUnitId";
      content = {
        orgUnitId: item?.orgUnitId
      };
    } else if (item?.playerId) {
      arrayName = "players";
      idName = "playerId";
      content = {
        playerId: item?.playerId
      };
    }

    if (isRemoveAccess) {
      state.selectedPeopleAndTeamsToShare?.deleted?.[arrayName].push(content);
      state.searchPeopleAndTeamsToShare = {
        ...state.searchPeopleAndTeamsToShare,
        [arrayName]: state.searchPeopleAndTeamsToShare?.[arrayName]?.filter(
          (i: { [x: string]: any }) => i?.[idName] !== item?.[idName]
        )
      };
    } else {
      state.selectedPeopleAndTeamsToShare.updated?.[arrayName].push(content);
    }
  },

  clearSelectedPeopleAndTeamsToShare: (state: {
    selectedPeopleAndTeamsToShare: object;
  }) => {
    state.selectedPeopleAndTeamsToShare = {
      deleted: {
        admins: [],
        orgUnits: [],
        players: []
      },
      updated: {
        admins: [],
        orgUnits: [],
        players: []
      }
    };
  },

  clearSearchPeopleAndTeamsToShareInDetails: (state: {
    searchPeopleAndTeamsToShareInDetails: object;
  }) => {
    state.searchPeopleAndTeamsToShareInDetails = {
      deleted: {
        admins: [],
        orgUnits: [],
        players: []
      },
      updated: {
        admins: [],
        orgUnits: [],
        players: []
      }
    };
  },

  setIsShareListNoResult: (
    state: { isShareListNoResult: boolean },
    payload: any
  ) => {
    state.isShareListNoResult = payload;
  },

  setPreviewDialogFile: (
    state: { previewDialogFile: object },
    payload: any
  ) => {
    state.previewDialogFile = payload.previewDialogFile;
  },

  setStorageItemTags: (
    state: { storageItemTags: any },
    payload: { storageItemTags: any }
  ) => {
    state.storageItemTags = payload.storageItemTags;
  }
};

const actions = {
  fetchStorageItemFavoriteState: async (
    context: {
      commit: (
        arg0: string,
        arg1: { storageItemId: any; isStorageItemFavorite: any }
      ) => void;
    },
    payload: { storageItemId: any }
  ) => {
    try {
      const { storageItemId } = payload;
      const res: any = await getRequest(
        `${StorageItemDetailsApiEndpoints.FETCH_STORAGE_ITEM_FAVORITE_STATE}/${storageItemId}`
      );
      context.commit("setStorageItemFavoriteState", {
        storageItemId,
        isStorageItemFavorite: res.data
      });
    } catch (e) {
      console.log(e);
    }
  },

  toggleStorageItemFavoriteState: async (
    context: any,
    payload: {
      state: { isStorageItemFavorite: any; storageItemId: any };
      playerId: any;
      orgAdmins: boolean;
    }
  ) => {
    try {
      const {
        state: { isStorageItemFavorite, storageItemId },
        playerId,
        orgAdmins
      } = payload;
      if (isStorageItemFavorite) {
        await deleteRequest(
          `${StorageItemDetailsApiEndpoints.DELETE_FAVORITE_STORAGE_ITEM}/${storageItemId}`
        );
      } else {
        const body = {
          playerId: playerId || null,
          orgAdmins: orgAdmins || null
        };
        await postRequest(
          `${StorageItemDetailsApiEndpoints.ADD_FAVORITE_STORAGE_ITEM}/${storageItemId}`,
          body
        );
      }

      setTimeout(() => {
        context.dispatch("academyNavigator/fetchFavoriteStorageItems", null, {
          root: true
        });
        context.dispatch("fetchStorageItemFavoriteState", { storageItemId });
        context.dispatch(
          "snackbar/SHOW_SNACKBAR",
          {
            text: isStorageItemFavorite
              ? i18n.tc("snackbar_message.removed_successfully")
              : i18n.tc("snackbar_message.added_successfully")
          },
          {
            root: true
          }
        );
      }, 500);
    } catch (e) {
      console.log(e);
    }
  },

  fetchStorageItemPresignedUrl: async (
    context: any,
    payload: {
      storageItemDetails: any;
      isDownloadStorageItem: any;
      callback?: Function;
    }
  ) => {
    try {
      const { storageItemDetails, isDownloadStorageItem, callback } = payload;
      const res: any = await getRequest(
        `${StorageItemDetailsApiEndpoints.FETCH_STORAGE_ITEM_PRESIGNED_URL}/${storageItemDetails.fileMetadata.id}`
      );
      context.commit("setPreviewResource", res.data);
      if (isDownloadStorageItem) {
        const link = res.data;
        axios
          .default(link, {
            [ApiRequestHeaderTypes.RESPONSE_TYPE]:
              ApiRequestHeaderValueTypes.BLOB
          })
          .then((response: any) => {
            if (!response?.data) return;
            const filename = storageItemDetails.fileMetadata.fileName;
            FileSaver.saveAs(response.data, filename?.split("UTF-8''").pop());
          })
          .catch((e: any) => console.error(e));
      } else if (callback) {
        callback(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  },

  fetchPeopleAndTeamsToShare: async (
    context: any,
    payload: {
      shareStorageItemSearchValue: string;
      organizationId: string;
      storageItemId: string;
      isStorageItemDetails: boolean;
    }
  ) => {
    const {
      shareStorageItemSearchValue,
      organizationId,
      storageItemId,
      isStorageItemDetails
    } = payload;
    context.commit("setIsShareListNoResult", false);

    context.commit("setSearchPeopleAndTeamsToShare", {
      isPeopleAndTeamsToShareLoading: true
    });

    try {
      const fetchPeopleAndTeamsToShareApiEndpoint = `${
        StorageItemDetailsApiEndpoints.FETCH_PEOPLE_AND_TEAMS_TO_SHARE
      }/${organizationId}/search-people-and-teams?storageItemId=${storageItemId}${
        shareStorageItemSearchValue
          ? `&filter=${encodeURIComponent(shareStorageItemSearchValue)}`
          : ""
      }`;

      const res: any = await getRequest(fetchPeopleAndTeamsToShareApiEndpoint, {
        timeout: 10000
      });
      if (res?.status === "success") {
        const { admins, orgUnits, players } = res?.data;
        const shareSubjectTypes = [admins, orgUnits, players];
        shareSubjectTypes.every(item => !item?.length)
          ? context.commit("setIsShareListNoResult", true)
          : context.commit("setIsShareListNoResult", false);

        if (!isStorageItemDetails) {
          context.commit("setSearchPeopleAndTeamsToShareSuccess", res?.data);
        } else {
          context.commit(
            "setSearchPeopleAndTeamsToShareInDetailsSuccess",
            res?.data
          );
          context.dispatch("academyNavigator/fetchRecentStorageItems", null, {
            root: true
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  },

  shareStorageItem: async (
    context: any,
    payload: {
      organizationId: string;
      selectedPeopleAndTeamsToShare: any;
      storageItemId: string;
      isStorageItemDetails?: boolean;
    }
  ) => {
    const {
      organizationId,
      selectedPeopleAndTeamsToShare,
      storageItemId,
      isStorageItemDetails
    } = payload;

    const body = {
      ...(!isStorageItemDetails
        ? {
            added: {
              admins: selectedPeopleAndTeamsToShare.admins?.map(
                (item: { accessType: any; userId: any }) => {
                  return {
                    accessType: item?.accessType,
                    userId: item?.userId
                  };
                }
              ),
              orgUnits: selectedPeopleAndTeamsToShare.teams?.map(
                (item: { orgUnitId: any }) => {
                  return {
                    orgUnitId: item?.orgUnitId
                  };
                }
              ),
              players: selectedPeopleAndTeamsToShare.players?.map(
                (item: { playerId: any }) => {
                  return {
                    playerId: item?.playerId
                  };
                }
              )
            }
          }
        : {}),
      deleted: context.getters?.selectedPeopleAndTeamsToShare?.deleted,
      storageItemId,
      updated: context.getters?.selectedPeopleAndTeamsToShare?.updated
    };

    try {
      const res: any = await postRequest(
        `${StorageItemDetailsApiEndpoints.SHARE_STORAGE_ITEM}/${organizationId}`,
        body
      );
      if (res?.status === "success") {
        context.commit("clearSelectedPeopleAndTeamsToShare");
        context.commit("clearSearchPeopleAndTeamsToShareInDetails");
        context.dispatch(
          "snackbar/SHOW_SNACKBAR",
          { text: i18n.tc("snackbar_message.sharing_updated") },
          {
            root: true
          }
        );
        context.dispatch("academyNavigator/fetchRecentStorageItems", null, {
          root: true
        });
        context.dispatch("fetchPeopleAndTeamsToShare", {
          organizationId,
          storageItemId,
          isStorageItemDetails: true
        });
      }
    } catch (e) {
      console.log(e);
    }
  },

  fetchStorageItemTagForStorageItem: async (
    context: { commit: (arg0: string, arg1: { storageItemTags: any }) => void },
    payload: {
      storageItemId: string;
    }
  ) => {
    const { storageItemId } = payload;

    try {
      const res: any = await getRequest(
        `${StorageItemDetailsApiEndpoints.GET_STORAGE_ITEM_TAG_FOR_STORAGE_ITEM}/${storageItemId}`
      );
      context.commit("setStorageItemTags", {
        storageItemTags: res?.data?.tags
      });
    } catch (e) {
      console.log(e);
    }
  },

  createNewTag: async (
    context: any,
    payload: {
      tag: string;
      callback: Function;
    }
  ) => {
    const { tag, callback } = payload;

    try {
      const res: any = await putRequest(
        StorageItemDetailsApiEndpoints.CREATE_NEW_TAG,
        { tag }
      );
      if (res?.status === "success") {
        let createdTag = null;
        await context.dispatch("searchTags", {
          filter: tag,
          callback: (response: any) => {
            createdTag = response?.tags?.find(
              (item: { tag: string }) => item?.tag === tag
            );
          }
        });
        callback && callback(createdTag);
      }
    } catch (e) {
      console.log(e);
    }
  },

  deleteTag: async (
    context: any,
    payload: {
      storageTagId: string;
      storageItemId: string;
    }
  ) => {
    const { storageTagId, storageItemId } = payload;

    try {
      const res: any = await deleteRequest(
        `${StorageItemDetailsApiEndpoints.DELETE_TAG}/${storageTagId}`
      );
      if (res?.status === "success") {
        context.dispatch(
          "storageItemDetails/fetchStorageItemTagForStorageItem",
          { storageItemId },
          { root: true }
        );
        context.dispatch(
          "snackbar/SHOW_SNACKBAR",
          { text: i18n.tc("snackbar_message.removed_successfully") },
          {
            root: true
          }
        );
      }
    } catch (e) {
      console.log(e);
    }
  },

  searchTags: async (_: any, payload: { filter: string; callback: any }) => {
    const { filter, callback } = payload;
    try {
      const res: any = await getRequest(
        `${
          StorageItemDetailsApiEndpoints.SEARCH_TAGS
        }?filter=${encodeURIComponent(filter)}`
      );
      callback && callback(res?.data);
    } catch (e) {
      console.log(e);
    }
  }
};

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
};
